import { GetterTree } from "vuex";
import { RootState } from "../types";
import { JobCandidateInt } from "./types";
export const getters: GetterTree<JobCandidateInt, RootState> = {};
